import { Box, Button, Paper, Stack, useMediaQuery, useTheme } from '@mui/material';
import ConfigIcon from '@old/assets/svg/specific/admin/gear-white.svg';
import ZoneIcon from '@old/assets/svg/mapOnWhite.svg';
import { useEffect, useState } from 'react';
import { InspectionRoundModal } from './inspecton-round-modal';
import i18n from '../../../libs/language';
import { IntegrationsModal } from './new-integrations-modal';
import SiloMetrix from '@old/assets/svg/SiloBagPage/silo-metrix-active.svg';
import Tune from '@old/assets/svg/AdministratorPage/tune.svg';
import { useNavigate } from 'react-router';
import { PATH } from '@old/data/core/paths';

import { useToggle } from '@old/hooks/core';
import { ToastAction } from '@old/ui/toast/toast-action';
import { CountrysideZoneModal } from './countryside-zone-modal';
interface AdminCustomizationBarProps {
  state?: boolean;
  onRefreshAlborList: (state: boolean) => void;
  setActionInUser: (value: boolean) => void;
}

export function AdminCustomizationBar({
  state,
  onRefreshAlborList,
  setActionInUser,
}: AdminCustomizationBarProps) {
  useEffect(() => {
    if (state) {
      setOpenModal('integration');
    }
  }, [state]);
  const navigate = useNavigate();

  const [openModal, setOpenModal] = useState<'' | 'integration' | 'patrol' | 'countryside_zone'>('');
  const [savePatrol, toggleSavePatrol] = useToggle(false);

  const handleOpenIntegrationModal = () => setOpenModal('integration');
  const handleOpenPatrolModal = () => setOpenModal('patrol');
  const handleOpenCountrysideZoneModal = () => setOpenModal('countryside_zone');
  const handleCloseModal = () => {
    setOpenModal('');
    // window.location.reload();
  };
  const theme = useTheme();
  const matchMD = useMediaQuery(theme.breakpoints.down('lg'));

  const handleSavePatrol = (val: boolean) => toggleSavePatrol(val);

  // const handleSaveCountrysideZone = () => {};

  const configButtonStyles = {
    color: '#FFF',
    fontSize: 12,
    borderRadius: 100,
    textTransform: 'none',
  };

  return (
    <>
      {savePatrol && (
        <ToastAction message={i18n.t('app.inspection_round_modal.saved_data')} severity="success" />
      )}
      <Paper
        sx={{
          borderRadius: 4,
          padding: 2,
          gridColumn: matchMD ? '' : '3/5',
          gridRow: matchMD ? '' : '0/1',
        }}
        elevation={0}
      >
        <Stack
          direction="row"
          style={{
            display: 'flex',
            gap: 10,
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              fontWeight: '600',
              fontSize: 17,
              display: 'flex',
              flex: 1,
              justifyContent: { xs: 'center', lg: 'left' },
              alignItems: 'center',
            }}
          >
            Personalizar
          </Box>
          <Stack
            direction="row"
            style={{
              display: 'flex',
              gap: 10,
              flexWrap: 'wrap',
            }}
          >
            <Stack
              direction="row"
              style={{
                display: 'flex',
                flex: 1,
                gap: 10,
                justifyContent: 'center',
              }}
            >
              <Button
                variant="contained"
                size="small"
                disableElevation
                startIcon={<img src={ConfigIcon} alt="add" />}
                sx={configButtonStyles}
                onClick={handleOpenPatrolModal}
              >
                {i18n.t('app.administrator.walkthrough')}
              </Button>
              <Button
                variant="contained"
                size="small"
                disableElevation
                startIcon={<img src={ZoneIcon} alt="zone" />}
                sx={configButtonStyles}
                onClick={handleOpenCountrysideZoneModal}
                // disabled={country_id === 2}
              >
                {i18n.t('app.administrator.countryside_zone')}
              </Button>
              <Button
                variant="contained"
                size="small"
                disableElevation
                startIcon={<img src={ConfigIcon} alt="add" />}
                sx={configButtonStyles}
                onClick={handleOpenIntegrationModal}
                // disabled={country_id === 2}
              >
                {i18n.t('app.integration_modal.integrations')}
              </Button>
              <Button
                variant="contained"
                size="small"
                disableElevation
                startIcon={<img src={Tune} alt="add" />}
                endIcon={<img src={SiloMetrix} alt="silometrix" />}
                sx={configButtonStyles}
                onClick={() => navigate(`${PATH.SILOMETRIX_THRESHOLD}`)}
              >
                Silometrix
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </Paper>
      {openModal === 'integration' && (
        <IntegrationsModal
          open={openModal === 'integration'}
          close={handleCloseModal}
          refreshAlborList={onRefreshAlborList}
        />
      )}
      {openModal === 'patrol' && (
        <InspectionRoundModal
          open={openModal === 'patrol'}
          onClose={handleCloseModal}
          handleSavePatrol={handleSavePatrol}
        />
      )}
      {openModal === 'countryside_zone' && (
        <CountrysideZoneModal
          open={openModal === 'countryside_zone'}
          onClose={handleCloseModal}
          // handleSaveCountrysideZone={handleSaveCountrysideZone}
          setActionInUser={setActionInUser}
        />
      )}
    </>
  );
}
